const {
    faCheckCircle,
    faCircleXmark,
    faExclamationTriangle,
} = require('@fortawesome/free-solid-svg-icons');

const DataType = Object.freeze({
    STRING: 'string',
    NUMBER: 'number',
    BOOLEAN: 'boolean',
    OBJECT: 'object',
});

const MODE = Object.freeze({
    QNA: 'qna',
});

const PROMPT = Object.freeze({
    DEFAULT: 'default',
});

const IMAGES = Object.freeze({
    CHAT_STEP_1: 'Step1.png',
    CHAT_STEP_2: 'Step2.png',
    CHAT_STEP_3: 'Step3.png',
});

const MENUITEMS = Object.freeze({
    HOME: 'Home',
    FUNCTIONALITIES: 'Functionalities',
    WORKFLOW: 'Workflow',
    PRICING: 'Pricing',
    CONTACT_US: 'Contact Us',
});

const PLATFORM = Object.freeze({
    ONE_DRIVE: 'OneDrive',
    GOOGLE_DRIVE: 'GoogleDrive',
});

// ResponseEnum.js
const ResponseEnum = Object.freeze({
    RESET: 'RESET',
    NOT_SURE: 'NOT SURE',
    YES: 'YES',
    NO: 'NO',
});

const CRAWL_STATUS_META = Object.freeze({
    COMPLETED: {
        color: 'text-green-600',
        icon: faCheckCircle,
        tooltip: 'Crawl completed successfully.',
    },
    FAILED: {
        color: 'text-red-600',
        icon: faCircleXmark,
        tooltip: 'Crawl failed.',
    },
    'PARTIALLY CRAWLED': {
        color: 'text-yellow-600',
        icon: faExclamationTriangle,
        tooltip: 'Only partial content was crawled.',
    },
    DEFAULT: {
        color: 'text-gray-500',
        icon: null,
        tooltip: 'Status unknown.',
    },
});

module.exports = {
    DataType,
    MODE,
    IMAGES,
    PROMPT,
    MENUITEMS,
    PLATFORM,
    ResponseEnum,
    CRAWL_STATUS_META,
};
